import loadReduxAction from 'modules/redux/actions/load'
import {
  TRAINING_USERS_ACTION,
  TRAINING_USERS_DOMAIN,
  TRAINING_USERS_ENDPOINT,
  TRAINING_USERS_PATH
} from 'modules/training/modules/training-users/constants'
import getEndpointTrainingUtil from 'modules/training/utils/get-endpoint'
import { logUtil } from 'packages/src'
import getPathReduxUtil from 'modules/redux/utils/get-path/index.js'
import getCurrentTrainingUserSelect from 'modules/training/modules/training-users/selectors/get-current/index.js'
import REDUX_OPTION from 'modules/redux/constants/option.js'

export default function loadCurrentUserAction () {
  return async (dispatch, getState) => {
    try {
      const user = getCurrentTrainingUserSelect(getState())
      logUtil('loadCurrentUserAction').debug('[start] user=', user)

      await dispatch(
        loadReduxAction({
          type: TRAINING_USERS_ACTION.LOAD_CURRENT,
          payload: {
            endpoint: getEndpointTrainingUtil(TRAINING_USERS_ENDPOINT.ROOT),
            domainListPath: TRAINING_USERS_PATH.ALL,
            domainPath: TRAINING_USERS_DOMAIN,
            path: getPathReduxUtil(user, TRAINING_USERS_DOMAIN)
          },
          options: {
            [REDUX_OPTION.SHOULD_KEEP_PATH]: true
          }
        })
      )
    } catch (error) {
      logUtil('loadCurrentUserAction').error('error=', error)
    }
  }
}
